/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementListEventEntryResponse } from './EventManagementListEventEntryResponse';

export type EventManagementListEventEntryResponseApiRespoonse = {
    data?: EventManagementListEventEntryResponse;
    status?: EventManagementListEventEntryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementListEventEntryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

